import InlineComponent from './inlineComponent.jsx';
import DateTime from '../../../components/DateTime.jsx';
module.exports = class DateTimeRenderer extends InlineComponent {
  define() {
    let zones = _.isEmpty(this.element.data('timezone'))
      ? 'user'
      : this.element.data('timezone');

    this.component = DateTime;
    this.data = {
      required: this.element.data('required') || false,
      value: _.isEmpty(this.element.data('value') + '')
        ? ''
        : this.element.data('value'),
      readonly: this.element.data('readonly') || false,
      name: this.element.data('name') || '',
      labels: this.element.data('labels') || [],
      zones:
        typeof zones === 'string' ? [zones.trim()] : zones.map((i) => i.trim()),
      error: this.element.data('error'),
      displayAll: this.element.data('displayAll'),
      includeSeconds: this.element.data('includeSeconds'),
    };
  }
};
